"use strict";

exports.__esModule = true;
exports.ReportGridView = ReportGridView;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _System = require("../../../System");
var _Theme = require("../../Theme");
var _ReportThumbnail = require("../ReportThumbnail");
var _Auth = require("../../Auth");
var _excluded = ["onItemClick", "items", "selectedIds"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ReportListItemThumbnail = (0, _styledComponents["default"])(_ReportThumbnail.ReportThumbnail).withConfig({
  displayName: "ReportGridView__ReportListItemThumbnail",
  componentId: "sc-gfbpai-0"
})([""]);
var ReportGridViewContainer = _styledComponents["default"].div.withConfig({
  displayName: "ReportGridView__ReportGridViewContainer",
  componentId: "sc-gfbpai-1"
})(["display:grid;height:100%;padding:1.25rem;grid-gap:1.25rem;grid-template-columns:repeat(auto-fill,minmax(calc(144px + 1rem),1fr));grid-template-rows:repeat(auto-fill,calc(144px + 2rem));"]);
var ReportGridViewItem = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "ReportGridView__ReportGridViewItem",
  componentId: "sc-gfbpai-2"
})(["color:", ";background:", ";box-shadow:0 0 5px ", ";border-radius:", ";transition:box-shadow 0.3s;transition:background 0.5s;padding:0.5rem;display:flex;flex-direction:column;justify-content:center;align-items:center;&:hover{text-decoration:none;color:", ";background:", ";box-shadow:0 0 5px ", ";}"], (0, _Theme.selectable)("ThumbnailListItemColor"), (0, _Theme.selectable)("ThumbnailListItemBackground"), (0, _Theme.selectable)("ThumbnailListItemShadow"), (0, _Theme.selectable)("ThumbnailListItemBorderRadius"), (0, _Theme.val)("SelectedThumbnailListItemColor"), (0, _Theme.val)("SelectedThumbnailListItemBackground"), (0, _Theme.val)("SelectedThumbnailListItemShadow"));
var ReportGridViewItemLabel = _styledComponents["default"].div.withConfig({
  displayName: "ReportGridView__ReportGridViewItemLabel",
  componentId: "sc-gfbpai-3"
})(["color:", ";display:block;height:32px;margin:0.25rem;font-size:0.875rem;text-align:center;line-height:1rem;"], (0, _Theme.selectable)("ThumbnailListItemColor"));

/**
 * Shows a list of reports.
 */
function ReportGridView(_ref) {
  var onItemClick = _ref.onItemClick,
    items = _ref.items,
    _ref$selectedIds = _ref.selectedIds,
    selectedIds = _ref$selectedIds === void 0 ? [] : _ref$selectedIds,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  function renderReportListRow(item) {
    return /*#__PURE__*/_react["default"].createElement(ReportGridViewItem, {
      key: item.id,
      "data-testid": "ReportGridViewItem",
      to: (0, _System.getScreenURL)("Report", item),
      "aria-selected": selectedIds.includes(item.id),
      onClick: typeof onItemClick !== "function" ? undefined : function (e) {
        e.preventDefault();
        onItemClick(item);
      }
    }, /*#__PURE__*/_react["default"].createElement(ReportListItemThumbnail, {
      width: 140,
      height: 105,
      report: item
    }), /*#__PURE__*/_react["default"].createElement(ReportGridViewItemLabel, {
      "data-testid": "ReportGridViewItem.label"
    }, item.name));
  }
  function renderExternalRow(item) {
    var Thumbnail = item.thumbnail;
    return /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
      key: item.id,
      permission: item.permission
    }, /*#__PURE__*/_react["default"].createElement(ReportGridViewItem, {
      key: item.id,
      "data-testid": "ReportGridViewItem",
      to: item.path
    }, /*#__PURE__*/_react["default"].createElement(Thumbnail, {
      width: 128,
      height: 128
    }), /*#__PURE__*/_react["default"].createElement(ReportGridViewItemLabel, {
      "data-testid": "ReportGridViewItem.label"
    }, item.name)));
  }
  return /*#__PURE__*/_react["default"].createElement(ReportGridViewContainer, _extends({
    "data-testid": "ReportGridView"
  }, extra), items.map(function (item) {
    // $FlowFixMe
    if (item.path) {
      // flow can't handle multiple ORs
      return renderExternalRow(item);
    }
    return renderReportListRow(item);
  }));
}